module.exports = __webpack_public_path__ + "static/media/background.1340889e.png";